import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Prodect_1 from '../../../assets/images/home_page_3/product-slider/01.png'
import Prodect_3 from '../../../assets/images/home_page_3/product-slider/03.png'
import Prodect_4 from '../../../assets/images/home_page_3/product-slider/04.png'
import Prodect_5 from '../../../assets/images/home_page_3/product-slider/05.png'
import Prodect_6 from '../../../assets/images/home_page_3/product-slider/06.png'

const Prodect = {
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Prodectslider = () => {
    return (
        <>
            <div id="product-slider-two" className="product-slider-two-main-block" >
                <div className="container-fluid">
                    <Slider className="slider product-slider-two-autoplay" {...Prodect}>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_3}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_3}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_4}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_5}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_6}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_1}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="product-slider-two-block">
                            <div className="item">
                                <img
                                    src={Prodect_5}
                                    className="img-fluid"
                                    alt=""
                                />
                                <div className="overlay-bg" />
                                <div className="product-slider-img-text">
                                    <h3 className="title">
                                        <Link to="/Shop" title="">
                                            Instagram
                                        </Link>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Prodectslider
